import { useAuthStore } from "@/stores/auth";
import { useBillingStore } from "@/stores/billing";

export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore();
  const billingStore = useBillingStore();
  const localePath = useLocalePath();

  // If user is not authenticated, continue (auth middleware will handle this)
  if (!authStore.loggedIn) {
    return;
  }

  const user = authStore.user;
  if (!user) return;

  const userRole = user.role;

  // Only check subscription for customer-admin and user roles
  if (userRole === 'user' || userRole === 'customer-admin') {
    // Ensure billing data is loaded
    if (!billingStore.featureFlags) {
      await billingStore.fetchFeatureFlags();
    }

    // Check if user has valid subscription or trial from billing summary
    if (!billingStore.hasValidSubscription()) {
      // If user doesn't have a valid subscription or active trial, redirect to billing
      // Unless they're already on the billing page
      if (to.path !== localePath('/dashboard/billing')) {
        return navigateTo(localePath('/dashboard/billing'));
      }
    }
  }
});
